import Link from 'next/link';
import classnames from 'classnames';

export default function CardLink({
  children,
  className,
  externalUrl,
  linkPath,
}) {
  const linkClassName = classnames(className, 'flex flex-1 flex-col group');

  if (externalUrl) {
    return (
      <a
        href={externalUrl}
        target="_blank"
        rel="nofollow noopener noreferrer"
        className={linkClassName}
      >
        {children}
      </a>
    );
  }

  return (
    <Link href={linkPath} prefetch={false}>
      <a className={linkClassName}>{children}</a>
    </Link>
  );
}
